$(function(){

  /****** ***Ввод в инпут только цифр ***********/

  $('.js-number').keypress(function(e){
    var charCode = (e.which) ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
  });

  /****** ****Ввод в инпут только букв ***********/
  $('.js-letter').inputmask('Regex',
    { regex: '^[а-яА-Яa-zA-Z ]*$' }
  );

  /*********** Маска для телефона **************/

  $('.js-phone').inputmask("+9(999)999-99-99",{ "clearIncomplete": true });

  /*********** Селект **************/
  var customSelect = $('.js-select');

  customSelect.select2();
  customSelect.find('span').addClass('needsclick');
  customSelect.addClass('default-option');

  customSelect.on("select2:select", function (e) {
    var id = $(this).find("option:selected").index();
    if (id == 0) $(this).addClass('default-option')
    else $(this).removeClass('default-option')
  });


//open btn and modal record

  var $btnModal = $('.js-btn-modal');

  $btnModal.on('click', function(){
    $('.record-form').slideToggle();
  });

  $('.js-popup-btn').on('click', function(){
    $('.record-form').hide();
  })

});
